/**
 * Registers the service worker that makes the app work with no connection.
 *
 * Only in a real build: during development a service worker would sit in front
 * of the dev server and serve yesterday's code, which is maddening. It also
 * needs a secure context, so it activates on https:// and on localhost, and
 * quietly does nothing on a plain http:// LAN address.
 */
export function registerOffline(): void {
  if (!import.meta.env.PROD) return;
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  if (!window.isSecureContext) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // Not being able to work offline is a shame, not a failure — the app
      // itself is already running, so say so quietly and carry on.
      console.warn('[offline] service worker not registered:', err);
    });
  });

  /*
   * When a new version has been deployed, the browser fetches it in the
   * background and parks it. Taking control immediately would swap the code out
   * from under someone mid-question, so the new copy is picked up the next time
   * the app is opened — which is what `skipWaiting` on the next start does.
   */
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // Nothing to do: the next launch already gets the new version.
  });
}
